import { render, staticRenderFns } from "./TextPropertyEditor.vue?vue&type=template&id=9afdb5cc&scoped=true&"
import script from "./TextPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./TextPropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afdb5cc",
  null
  
)

export default component.exports